import CryptoJS from "crypto-js";
import * as XLSX from 'xlsx';
import logo from "../../../assets/logo_login.jpeg"
import { loadingOverlay}  from "vuetify-more-component";



export default {

  components: {
    logo,
    loadingOverlay
  },

  data() {
    return {
      logo,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      search: "",
      loading: false,

      data_usuario: -1,
      usuarios: [],
      searchnit: '',

      headers: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Período Presentado",
          value: "fecha_presentacion"
        },
        {
          text: "Dia de declaración",
          align: "center",
          sortable: true,
          value: "fecha_seguimiento"
        },
        {
          text: "Regimen",
          align: "center",
          sortable: true,
          value: "regimen"
        },
        {
          text: "Total facturas ventas Q.",
          align: "end",
          sortable: true,
          value: "total_fatura"
        },
        {
          text: "Total Retenciones Q.",
          align: "end",
          sortable: true,
          value: "total_retencion"
        },
        {
          text: "Pago de impuesto Q.",
          align: "center",
          sortable: true,
          value: "pago"
        },
        {
          text: "Facturas",
          align: "center",
          sortable: true,
          value: "facturas"
        },
        {
          text: "Retenciones",
          align: "center",
          sortable: true,
          value: "retenciones"
        },
        {
          text: "Estado de la declaración",
          align: "center",
          sortable: true,
          value: "estado"
        },
        {
          text: "Tipo suscripción",
          align: "center",
          sortable: true,
          value: "abreviatura"
        },
        {
          text: "Colaborador TIC asignado",
          align: "center",
          sortable: true,
          value: "asignado"
        },
        {
          text: "Pago realizado",
          align: "center",
          sortable: true,
          value: "pago_realizado"
        },
        {
          text: "Fact. y Ret.",
          align: "center",
          sortable: true,
          value: "resumen"
        },
        {
          text: "Eliminar Seguimiento",
          align: "center",
          sortable: false,
          value: "accion"
        },
      ],

      presentaciones: [],

      fecha: {
        fecha: "",
        fecha_usuario: "",
      },

      item_aux: '',

      dialog: false,

      text: "Copiar",
      copyText: '',

      facturas: [],
      retenciones: [],

      usuario: -1,

      dialogCancelarSeguimiento: false,

      mes_declaracion: "",
      anio: "",

      usuario_aux: null,

      impuesto_sin_retenciones: 0,


      mes: {

        1: 'enero',
        2: 'febrero',
        3: 'marzo',
        4: 'abril',
        5: 'mayo',
        6: 'junio',
        7: 'julio',
        8: 'agosto',
        9: 'septiembre',
        10: 'octubre',
        11: 'noviembre',
        12: 'diciembre',
      },
      log_roles: [],

      dialogrosIVA: false,
      dialogrosISR: false,


      meses: {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre"
      },

      items_formulario: [],
      loadingActualizacion: false,
    }
  },

  watch: {
    dialogrosIVA(val) {
      console.log("dialog ros iva", val);
      if (!val) {
        this.loadingActualizacion = true;
        this.listadoSeguimiento(this.usuario_aux);

      }
    }
  },

  async created() {
    // await this.listadoSeguimiento();
    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      //Casteo de información a estring
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      //Casteo de JSON String a Object json
      let r = JSON.parse(informacion_desincriptada)
      // console.log("data encriptada");
      // console.log(r);
      this.log_roles = r.rol;
      this.usuario = r.usuario[0]
    }

    await this.getClientes();
    await this.getTipo_registro_listado_activos()
  },

  computed: {
    totalRetenciones() {
      let total = 0
      this.retenciones.filter(x => {
        if (x.anulado != 1) {
          total = parseFloat(total) + parseFloat(x.total_retencion);
        }
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.round(total));
    },

    totalFacturas() {
      let total = 0
      this.facturas.filter(x => {
        if (x.anulado != 1) {
          total = parseFloat(total) + parseFloat(x.monto);
        }
      });

      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });

      console.log("total de facturas");
      console.log(total);

      this.impuesto_sin_retenciones = total * 0.05
      this.impuesto_sin_retenciones = dollarUSLocale.format(this.impuesto_sin_retenciones)

      return dollarUSLocale.format(parseFloat(total).toFixed(2));
    }
  },

  methods: {

    async getTipo_registro_listado_activos() {
      try {
        console.log("llego");
        let r = await this.$store.state.services.administradorService.getTipo_registro_listado_activos();
        console.log("activos", r);
        r.data.data.filter(item => { item.base = 0, item.creditos = 0 })
        this.items_formulario = r.data.data;
        // ordena los items por orden
        this.items_formulario.sort((a, b) => (a.orden > b.orden) ? 1 : -1)
        this.items_formulario.push({ titulo_formulario: "Sumatoria de las columnas BASE y CRÉDITOS ", id: -2, orden: "-1", base: 0, creditos: 0 })

      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener el listado de pedidos activos")
      }
    },

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(parseFloat(numero).toFixed(2)))
    },

    exportarExcel() {
      let info = [];
      this.presentaciones.forEach(element => {

        let data = {
          CUI: element.cui,
          NOMBRE: element.nombre,
          NIT: element.nit,
          PASSWORD_SAT: element.password_sat,
          PERIODO_PRESENTADO: (element.fecha_presentacion != null ? (this.mes === parseInt(element.fecha_presentacion.split("-")[1])) ? this.mes[12] +
            " " +
            (parseInt(element.fecha_presentacion.split("-")[0])) :
            this.mes[parseInt(element.fecha_presentacion.split("-")[1])] + " " +
            element.fecha_presentacion.split("-")[0] : ''),
          DIA_DECLARACION: element.fecha_seguimiento,
          TOTAL_FACTURA: element.total_factura,
          TOTAL_RETENCIONES: element.total_retencion,
          PAGO_IMPUESTO: element.pago,
          FACTURAS: element.facturas,
          RETENCIONES: element.retenciones,
          REGISTRO_COLABORADOR: element.asignado_id,
          NOMBRE_COLABORADOR: element.asignado,
          PAGO_REALIZADO: element.pago_realizado,
        }
        info.push(data);
      });
      console.log("info");
      console.log(info);
      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'seguimiento_' + this.date;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

    async copyCode(tipo, item) {

      switch (tipo) {
        case 1:
          await navigator.clipboard.writeText(this.totalFacturas.replace(",", ""));
          this.copyText = "Copiado"
          break;

        case 2:

          await navigator.clipboard.writeText(this.retenciones.replace(",", ""));
          this.copyText = "Copiado"
          break;

        case 3:
          await navigator.clipboard.writeText(item);
          this.copyText = "Copiado"
          break;

        default:
          break;
      }
    },

    async listadoSeguimiento(usuario) {
      if (usuario == null) {
        // this.$toast.error("Debe seleccionar un usuario");
        return;
      }

      try {
        this.usuario_aux = usuario;
        this.loading = true;
        let r =
          await this.$store.state.services.presentacionService.getSeguimiento(usuario);
        let num = 0;
        r.data.data.forEach(element => {
          element.num = num++;
          element.loading = false;
        });

        this.presentaciones = r.data.data;
        console.log("declaraciones ");
        console.log(this.presentaciones);
        this.loading = false;
        this.loadingActualizacion = false;
      } catch (error) {
        this.loading = false;
        this.loadingActualizacion = false;
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los seguimientos"
        );
      }
      console.log(usuario);
    },


    async verDialog(item, opc) {
      this.loading = true;
      this.item_aux = item;
      item.loading = true;

      if (item.estado != 'No iniciada') {
        let fecha_solicitada = item.fecha_presentacion;
        fecha_solicitada = fecha_solicitada.split("-");
        let mes = parseInt(fecha_solicitada[1]);
        // let mes = 1;
        let mes_declaracion = mes;
        let anio = parseInt(fecha_solicitada[0])
        // mes === 1 ? (anio = anio - 1, mes_declaracion = 12) : console.log("anio: " + anio);
        this.mes_declaracion = mes_declaracion;
        this.anio = anio;

        console.log('item');
        console.log(item);
        await this.getPresentarFacturas(item);
        await this.getPresentarRetenciones(item);
        switch (item.regimen_id) {
          case 1:
            this.dialog = true;
            break;
          case 2:
            if (opc === 1) {
              this.dialogrosISR = true;

            } else if (opc === 2) {
              this.dialogrosIVA = true;
              let base_acumlada = 0;
              let creditos_acumulados = 0;

              for (const key in item.ros) {
                const CFOL = item.ros[key];
                if (CFOL.tipo_registro_id != 9) {

                  console.log("CRÉDITO FISCAL POR OPERACIONES LOCALES", CFOL);
                  let item_formulario = this.items_formulario.find(
                    (item) => item.id === CFOL.tipo_registro_id
                  );
                  item_formulario.base = CFOL.monto_sin_iva;
                  item_formulario.creditos = CFOL.monto_iva;
                  base_acumlada += parseFloat(CFOL.monto_sin_iva);
                  creditos_acumulados += parseFloat(CFOL.monto_iva);
                }
              }
              // accede al ultime item de items_formulario
              this.items_formulario[this.items_formulario.length - 1].base = base_acumlada;
              this.items_formulario[this.items_formulario.length - 1].creditos = creditos_acumulados;
            }

            break;


        }
        this.loading = false;
        item.loading = false;

      } else {
        this.$toast.info("Estado de declaración no iniciada")
        item.loading = false;
        this.loading = false;

      }
    },

    deleteSeguimiento(item) {
      this.item_aux = item;
      console.log("item aux");
      console.log(this.item_aux);
      this.dialogCancelarSeguimiento = true;
    },

    async deleteSeguimientoConfirmar() {
      try {
        this.loading = true;
        let r =
          await this.$store.state.services.presentacionService.deleteSeguimiento({ id: this.item_aux.id });

        console.log("eliminar seguimiento");
        console.log(r);
        this.$toast.success("Seguimiento eliminado satisfactoriamente")
        // this.presentaciones = r.data.data;
        // console.log("this.presentaciones");
        // console.log(this.presentaciones);
        this.listadoSeguimiento(this.usuario_aux);
        this.item_aux = '';
        this.dialogCancelarSeguimiento = false;
        this.loading = false;
      } catch (error) {
        this.dialogCancelarSeguimiento = false;
        this.loading = false;
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los seguimientos"
        );
      }
    },

    reset() {
      this.copyText = this.text
    },

    async getPresentarFacturas(item) {
      try {
        let r =
          await this.$store.state.services.presentacionService.getPresentarFacturas(item.id);
        this.facturas = r.data.data;
        console.log("this.facturas");
        console.log(this.facturas);
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de las declaraciones"
        );
      }
    },
    async getPresentarRetenciones(item) {
      try {
        let r =
          await this.$store.state.services.presentacionService.getPresentarRetenciones(item.id);
        this.retenciones = r.data.data;
        console.log("this.retenciones");
        console.log(this.retenciones);
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de las declaraciones "
        );
      }
    },

    async getClientes() {
      this.loading = true;
      try {
        let r =
          await this.$store.state.services.presentacionService.getClientes();
        console.log("usuarios");
        console.log(r);
        r.data.data.filter((x) => {
          x.nombre =
            x.primer_nombre +
            " " +
            x.segundo_nombre +
            " " +
            x.primer_apellido +
            " " +
            x.segundo_apellido;

          x.nombre = x.nombre.replace("null", "");
        });
        this.usuarios = r.data.data;
        this.loading = false;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los Colaboradores TIC"
        );
        console.log(error);
        this.loading = false;
      }
    },

  },
}